import browserFilter from '@/src/module/jhc-browser-filter';
import anime from 'animejs/lib/anime.es.js';

const scrollMove= ( elem, duration, delay, callback, wrapper )=> {
	const top= getOffset(elem, wrapper);
	scrollMoveEvt( top, duration, delay, callback, wrapper );
}

const scrollMoveEvt= ( offsetTop, duration, delay, callback, wrapper )=> {
	const scrollElement = wrapper || (window.document.scrollingElement || window.document.body || window.document.documentElement);
	duration= duration || 500;
	delay= delay || 0;

	const topPos= offsetTop-114;
  if( browserFilter() ) {
    window.scrollTo(0, topPos)
    callback && callback()
  } else {
  	anime({
      targets: scrollElement,
      scrollTop: topPos,
      duration: duration,
      delay: delay,
      easing: 'easeInOutQuad',
      complete: (anime)=> callback && callback(anime)   
    });
  }
}

const getOffset= ( elem, wrapper )=> {
	const clientRect = elem.getBoundingClientRect(); // DomRect 구하기 (각종 좌표값이 들어있는 객체)
	const relativeTop = clientRect.top; // Viewport의 시작지점을 기준으로한 상대좌표 Y 값.
	const scrolledTopLength = wrapper ? wrapper.scrollTop : window.pageYOffset; // 스크롤된 길이
	const absoluteTop = scrolledTopLength + relativeTop; // 절대좌표

	return absoluteTop;
}


export default scrollMove;